import type { Action } from "../../actions/types";
import get from "lodash/get";

export interface MemberTierCustomer {
  customerId?: string;
  merchantId?: string;
  memberTierId?: string;
  memberTierNameCached?: string;
  pointsBalance?: object;
  pointsAccumulator?: object;
  memberTierPoints?: object;
  pointsCurrency?: string;
  nextTier?: object;
  tierExpirationDate?: string;
  // duplicated for merge vars
  current?: string;
  next?: string;
  valueEarned?: string;
  valueNeeded?: string;
  expiration?: string;
}

export type StoreState = MemberTierCustomer;

export const initialState = {};

export function reducer(
  state: StoreState | null = initialState,
  action: Action
): StoreState | null {
  if (action.type === "GET_MEMBER_TIER_CUSTOMER_SUCCESS") {
    const data = action.response.data;
    const toReturn = {
      ...action.response.data,
      current: data.memberTierNameCached,
      next: get(data, "nextTier.memberTierNameCached"),
      earned: get(data, "pointsAccumulator.pointsEarned"),
      needed: get(data, "nextTier.pointsRequired"),
      expiration: get(data, "variables.currentTier.expiresOn.fv"),
      points: get(data, "variables.points.v"),
    };

    return toReturn;
  }

  return state;
}
